import Others1 from './../images/works/Others/10926275_878176462232682_1298555271027059032_o.jpg'
import Others2 from './../images/works/Others/Bag Sample Design_Side_1.jpg'
import Others3 from './../images/works/Others/Eid-Card_02.a.png'
import Others4 from './../images/works/Others/Final-design.jpg-1.jpg'
import Others5 from './../images/works/Others/Sample Design_Bag_3.jpg'
import Others6 from './../images/works/Others/Standee_05_4X6.jpg'

const Others = [Others1, Others2, Others3, Others4, Others5, Others6]

export default Others